<!--
  SocialLinks — read-only brand-icon list of a contributor's/location's socials.
  Each icon links to the resolved profile URL in a new tab. Falls back to the
  platform emoji when no brand SVG exists.
-->
<template>
  <span class="social-links">
    <a v-for="(s, i) in links" :key="i"
       :href="socialUrl(s.platform, s.url)" target="_blank" rel="noopener"
       class="social-link" :title="platformLabel(s.platform) + ': ' + s.url">
      <svg v-if="platformSvg(s.platform)" viewBox="0 0 24 24" class="brand-svg" aria-hidden="true"><path :d="platformSvg(s.platform)" fill="currentColor" /></svg>
      <template v-else>{{ platformIcon(s.platform) }}</template>
    </a>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { platformIcon, platformLabel, platformSvg, socialUrl } from '@/lib/socialPlatforms'

const props = defineProps<{ socials?: Array<{ platform: string; url: string }> | null }>()
const links = computed(() => (props.socials || []).filter(s => s && s.platform && s.url))
</script>

<style scoped>
.social-links { display: inline-flex; gap: 0.35rem; align-items: center; }
.social-link {
  display: inline-flex; align-items: center; justify-content: center;
  width: 1.3rem; height: 1.3rem; color: var(--text-muted);
  border-radius: var(--radius-sm); transition: color 0.12s, background 0.12s;
}
.social-link:hover { color: var(--accent-text); background: var(--accent-dim); }
.brand-svg { width: 0.95rem; height: 0.95rem; display: block; }
</style>
